import { ErrorHandler, Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

/**
 * Central catch-all for errors that no subscriber handles (most HTTP calls in
 * this app subscribe without an error callback). Extend this to surface errors
 * to the user (e.g. via NotificationService) instead of only the console.
 */
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

  handleError(error: unknown): void {
    // Angular wraps errors from async code; unwrap to the original rejection.
    const unwrapped = (error as { rejection?: unknown })?.rejection ?? error;

    if (unwrapped instanceof HttpErrorResponse) {
      console.error(`[http ${unwrapped.status}] ${unwrapped.url}`, unwrapped.error ?? unwrapped.message);
      return;
    }

    console.error(unwrapped);
  }
}
